import { tv, type VariantProps } from "@/lib/utils/tv"

const divider = tv({
  base: "w-full",
  variants: {
    tone: {
      subtle: "h-px bg-line-subtle",
      dashed: "h-px border-t border-dashed border-line bg-transparent",
    },
  },
  defaultVariants: { tone: "subtle" },
})

export const Divider = ({ tone, className }: VariantProps<typeof divider> & { className?: string }) => <div role="separator" className={divider({ tone, className })} />
